export default __webpack_public_path__ + "static/media/dynamic-removebg-preview1.8cea737c.svg";